<template>
	<router-view></router-view>
</template>

<script>
	export default {

	}
</script>

<style>
	html,
	body {
		margin: 0;
		padding: 0;
		height: 100%;
	}

	#app {
		height: 100%;
	}
</style>
